export enum ProductionUnit {
  TON = 'TON',
  TON_PER_DAY = 'TON/d',
  BOE = 'boe',
  MCF = 'mcf',
  BOE_PER_DAY = 'boe/d',
}
